import { MAX_LOCATIONS, type WidgetLocation } from '@omnia/shared';

const sameCity = (a: WidgetLocation, b: WidgetLocation) => a.lat.toFixed(2) === b.lat.toFixed(2) && a.lon.toFixed(2) === b.lon.toFixed(2);

/** Adds a city at the end; a city already saved, or a sixth one, leaves the list as it is. */
export function addLocation(list: WidgetLocation[], place: WidgetLocation): WidgetLocation[] {
  if (list.length >= MAX_LOCATIONS || list.some((item) => sameCity(item, place))) return list;
  return [...list, place];
}

/** Removes a city, but never the last one: the bar always has a place to show. */
export function removeLocation(list: WidgetLocation[], index: number): WidgetLocation[] {
  if (list.length <= 1 || index < 0 || index >= list.length) return list;
  return list.filter((_, i) => i !== index);
}

/** The first city is the primary one, so making a city primary moves it to the front. */
export function makePrimary(list: WidgetLocation[], index: number): WidgetLocation[] {
  const city = list[index];
  if (!city || index === 0) return list;
  return [city, ...list.filter((_, i) => i !== index)];
}

export function moveLocation(list: WidgetLocation[], index: number, delta: -1 | 1): WidgetLocation[] {
  const target = index + delta;
  if (index < 0 || index >= list.length || target < 0 || target >= list.length) return list;
  const next = [...list];
  [next[index], next[target]] = [next[target]!, next[index]!];
  return next;
}
